{
  "holdingAreaListItem": {
    "imageAlt": "k.A.",
    "tenantTypes": {
      "transient": "Durchreisend",
      "base": "Basis",
      "yellowCard": "Basis + Yellow Card"
    },
    "unknownModel": "Unbekanntes Modell",
    "buttons": {
      "assign": "Zuweisen",
      "edit": "Bearb.",
      "remove": "Entfernen"
    },
    "confirmDialog": {
      "title": "Flugzeug aus dem Wartebereich entfernen?",
      "text": "Möchtest du {{identifier}} wirklich aus dem Wartebereich entfernen?",
      "okButton": "Entfernen",
      "cancelButton": "Abbrechen"
    }
  },
  "assignAircraftDialog": {
    "title": "Flugzeug zu Standort zuweisen",
    "sections": {
      "hangars": "Hangars",
      "ramps": "Vorfeld"
    },
    "messages": {
      "mayBeTooSmall": "Möglicherweise zu klein",
      "noLocations": "Keine Hangars oder Abstellflächen verfügbar"
    },
    "buttons": {
      "cancel": "Abbrechen",
      "assign": "Zuweisen",
      "assigning": "Wird zugewiesen..."
    }
  },
  "holdingAreaPresenter": {
    "title": "Wartebereich"
  },
  "holdingAreaList": {
    "title": "Wartebereich ({{count}})",
    "emptyState": "Keine Luftfahrzeuge im Wartebereich"
  },
  "printLayout": {
    "hangarCount": "{{count}} Hangar",
    "sqft": " ft²",
    "aircraft": "Flugzeug",
    "utilization": "Auslastung"
  },
  "multiHangarInfoCard": {
    "title": "Multi-Hangar-Übersicht",
    "labels": {
      "aircraft": "Flugzeug",
      "utilization": "Auslastung",
      "totalSqft": "Fläche (sqft)",
      "totalUtilized": "Gesamt genutzt",
      "estValue": "Gesch. Wert",
      "total": "Total",
      "transients": "Transients",
      "estTowTime": "Schleppzeit"
    },
    "tooltips": {
      "numberOfHangars": "Anzahl ausgewählter Hangars",
      "aircraftCount": "Flugzeuge in Hangars / Gesamtzahl Flugzeuge in ausgewählten Hangars",
      "utilization": "Kombinierte Auslastung aller ausgewählten Hangars",
      "totalSqft": "Gesamte Hangarfläche aller ausgewählten Hangars",
      "totalUtilized": "Gesamte von Flugzeugen belegte Bodenfläche",
      "estValue": "Geschätzter Gesamtwert aller Hangars pro Tag",
      "transientValue": "Revenue from overnight transient aircraft.",
      "estTowTime": "Geschätzte Gesamtschleppzeit über alle Hangars"
    }
  }
}
